<template>
  <div class="bienvenida-page">
    <div class="stars-container">
      <div class="star" v-for="n in 50" :key="n" :style="generateStarStyle()"></div>
    </div>

    <br>    <br>
    <br>
    <br>
    <br>
    <br><br>
    <br>

    <p class="versiculo-referencia-fija" ref="versiculoRef"></p>

    <div class="fecha-evento" ref="fechaRef">
      <p class="fecha-gran-dia" ref="granDiaRef">Save the Date</p>
      <p class="fecha-dia-semana" ref="diaSemanaRef">Saturday</p>
      <p class="fecha-dia-numero" ref="numeroRef">06</p>
      <p class="fecha-mes" ref="mesRef">JUNE</p>
      <p class="fecha-anio" ref="anioRef">2026</p>
    </div>

    <div class="bienvenida-container">
      <div class="contenido-bienvenida">
        <div class="mensaje-bienvenida" ref="mensajeRef">
          {{ mensaje }}
        </div>
        <div class="versiculo-container" ref="versiculoTextRef">
          <p class="versiculo-texto">
            On this blue night, I can touch the stars with my hands,
            I can borrow them from the sky and give them one by one to my
            dearest family members and my most sincere friends. <br>
            <br> You are one of them, and that is why
            I want you to come and find your star.
            <br>
            <br>
            <br>  
          </p>
        </div>
      </div>
    </div>

    <div class="disco-group disco1-group">
      <img src="@/assets/ff1.png" alt="disco" class="disco" ref="disco1Ref" />
    </div>

    <div class="disco-group disco2-group">
      <img src="@/assets/ff2.png" alt="disco" class="disco" ref="disco2Ref" />
    </div>

    <div class="disco-group disco3-group">
      <img src="@/assets/ff3.png" alt="disco" class="disco" ref="disco3Ref" />
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import { gsap } from 'gsap';

export default {
  name: 'BienvenidaPage',
  setup() {
    const mensaje = ref('');

    const granDiaRef = ref(null);
    const diaSemanaRef = ref(null);
    const numeroRef = ref(null);
    const mesRef = ref(null);
    const anioRef = ref(null);
    const mensajeRef = ref(null);
    const versiculoTextRef = ref(null);
    const versiculoRef = ref(null);

    const disco1Ref = ref(null);
    const disco2Ref = ref(null);
    const disco3Ref = ref(null);

    const estrella1Ref = ref(null);
    const estrella2Ref = ref(null);
    const estrella3Ref = ref(null);

    // Función para geasasnerar estrellas aleatorias
    const generateStarStyle = () => {
      const top = Math.random() * 100;
      const left = Math.random() * 100;
      const size = Math.random() * 3 + 1;
      const duration = Math.random() * 3 + 2;
      const delay = Math.random() * 5;
      
      return {
        top: `${top}%`,
        left: `${left}%`,
        width: `${size}px`,
        height: `${size}px`,
        animationDuration: `${duration}s`,
        animationDelay: `${delay}s`
      };
    };

    const animateOnScroll = (el, animationFn) => {
      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            animationFn();
            observer.unobserve(el);
          }
        },
        { threshold: 0.3 }
      );
      if (el) observer.observe(el);
    };

    onMounted(() => {
      // Animaciones de texto
      animateOnScroll(granDiaRef.value, () =>
        gsap.fromTo(granDiaRef.value, { opacity: 0, y: 30 }, { opacity: 1, y: 0, duration: 0.8 })
      );
      animateOnScroll(diaSemanaRef.value, () =>
        gsap.fromTo(diaSemanaRef.value, { opacity: 0, y: 20 }, { opacity: 1, y: 0, duration: 0.8 })
      );
      animateOnScroll(numeroRef.value, () =>
        gsap.fromTo(numeroRef.value, { opacity: 0, y: -80, scale: 0.7 }, { opacity: 1, y: 0, scale: 1, duration: 1.2, ease: 'bounce.out' })
      );
      animateOnScroll(mesRef.value, () =>
        gsap.fromTo(mesRef.value, { opacity: 0, y: 20 }, { opacity: 1, y: 0, duration: 0.8, delay: 0.2 })
      );
      animateOnScroll(anioRef.value, () =>
        gsap.fromTo(anioRef.value, { opacity: 0, y: 20 }, { opacity: 1, y: 0, duration: 0.8, delay: 0.3 })
      );
      animateOnScroll(mensajeRef.value, () =>
        gsap.fromTo(mensajeRef.value, { opacity: 0, y: 50 }, { opacity: 1, y: 0, duration: 1 })
      );
      animateOnScroll(versiculoTextRef.value, () =>
        gsap.fromTo(versiculoTextRef.value, { opacity: 0, y: 40 }, { opacity: 1, y: 0, duration: 1 })
      );
      animateOnScroll(versiculoRef.value, () =>
        gsap.fromTo(versiculoRef.value, { opacity: 0, y: 20 }, { opacity: 1, y: 0, duration: 1 })
      );

      const animateDiscoConEstrella = (discoEl, estrellaEl, delay = 0) => {
        const tl = gsap.timeline({ delay });
        tl.fromTo(discoEl, { opacity: 0, rotate: 0, scale: 0.5 }, { opacity: 1, rotate: 360, scale: 1, duration: 1.4, ease: "power3.out" })
          .fromTo(estrellaEl, { opacity: 0, scale: 0.5 }, { opacity: 1, scale: 1, duration: 1, ease: "back.out(1.7)" }, "+=0.1");
      };

      if (disco1Ref.value) animateOnScroll(disco1Ref.value, () => animateDiscoConEstrella(disco1Ref.value, estrella1Ref.value));
      if (disco2Ref.value) animateOnScroll(disco2Ref.value, () => animateDiscoConEstrella(disco2Ref.value, estrella2Ref.value, 0.2));
      if (disco3Ref.value) animateOnScroll(disco3Ref.value, () => animateDiscoConEstrella(disco3Ref.value, estrella3Ref.value, 0.4));
    });

    return {
      mensaje,
      granDiaRef,
      diaSemanaRef,
      numeroRef,
      mesRef,
      anioRef,
      mensajeRef,
      versiculoTextRef,
      versiculoRef,
      disco1Ref,
      disco2Ref,
      disco3Ref,
      estrella1Ref,
      estrella2Ref,
      estrella3Ref,
      generateStarStyle
    };
  }
};
</script>

<style scoped>
.bienvenida-page {
  position: relative;
  width: 100%;
  min-height: 100dvh;
  overflow: hidden; /* Evita scroll por las estrellas */

  background-image: 
    linear-gradient(to bottom, 
      rgba(0, 0, 0, 0.516) 60%, 
      rgba(0, 0, 0, 0.7) 85%, 
      rgba(0, 0, 0, 0.95) 100%
    ),
    url('@/assets/descarga (3).png');

  background-size: cover;
  background-position: center center; 
  background-repeat: no-repeat;

  color: #ffffff;
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

/* Sistema de estrellas */
.stars-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 0;
}

.star {
  position: absolute;
  background: white;
  border-radius: 50%;
  opacity: 0.3;
  box-shadow: 0 0 10px white;
  animation: twinkle linear infinite;
}

@keyframes twinkle {
  0% { opacity: 0.2; transform: scale(1); }
  50% { opacity: 1; transform: scale(1.2); }
  100% { opacity: 0.2; transform: scale(1); }
}

/* Fecha */
.fecha-evento {
  position: relative;
  z-index: 1;
  text-align: center;
  margin: 60px 0 40px; 

  color:#a48250;
}
.fecha-gran-dia {
  font-family: 'british', cursive;
  font-size: 32px;
  margin: 0;
}
.fecha-dia-semana {
  font-family: 'fecha', serif;
  font-size: 29px;
  margin: 10px 0;
}
.fecha-dia-numero {
  font-family: 'fecha', serif;
  font-size: 72px !important;
  font-weight: bold;
  margin: 0;
}
.fecha-mes {
  font-family: 'Playfair Display', serif;
  font-size: 26px;
  font-weight: 600;
  margin-top: 5px;
  letter-spacing: 2px;
}
.fecha-anio {
  font-family: 'Poppins', sans-serif;
  font-size: 16px;
  font-style: italic;
  margin-top: 5px;
}

/* Contenido */
.bienvenida-container {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.mensaje-bienvenida {
  font: 300 19px 'Josefin Sans', sans-serif;
  color: #000;
  white-space: pre-line;
  text-align: center;
  line-height: 2;
  opacity: 0;
}
.versiculo-container {
  margin: 30px 20px 0 20px;
  text-align: center;
  opacity: 0;
}
.versiculo-texto {
  font: 20px 'quote', sans-serif;
  line-height: 1.8;
  color: #9ea190;
  margin-left: 0 !important;
  margin-right: 0 !important;
}
.versiculo-referencia-fija {
  position: relative;
  z-index: 1;
  font: 24px 'nombre', sans-serif;
  color: #070707;
  margin-top: 40px;
  opacity: 0;
  text-align: center;
}

/* Discos con estrellas */
.disco-group {
  position: absolute;
  pointer-events: none;
  z-index: 2;
}
.disco {
  width: 100px;
  height: 120px;
}
.estrellas {
  width: 100px;
  position: absolute;
  bottom: -45px;
  left: 0;
  transform: rotate(-10deg);
  opacity: 0;
}

.disco1-group { top: -10%; right: -10%; }
.disco2-group { top: 35%; left: -5%; width: 120px; height: 140px; }
.disco3-group { bottom: 45%; left: -5%; z-index:10; }
</style>